module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre_25",
    attrs: {
      "id": "filepos80869"
    }
  }, [_c('span', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "italic1"
  }, [_vm._v("11 "), _c('img', {
    staticClass: "calibre11",
    attrs: {
      "alt": "image",
      "src": "images/00004.jpg"
    }
  }), _vm._v(" Débris - I")])])]), _c('div', {
    staticClass: "calibre_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_18"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("There may well be “dog” (in Reality), but there cannot be such a thing as a dog.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_2"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "Image",
      "src": "images/00002.jpg"
    }
  })])]), _c('div', {
    staticClass: "calibre_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("What justification could there be for regarding the bodies of living things as having any higher value, or nobler purpose, than that of prospective manure? According to what law is there any higher?")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_2"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "Image",
      "src": "images/00002.jpg"
    }
  })])]), _c('div', {
    staticClass: "calibre_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Play your part in the comedy, but don’t identify yourself with your role!")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_20"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Manifestations of multiple energies, what else are men?")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_20"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Karma is not a thing-in-itself nor a system invented by some esoteric religion. “Karma” is a short and convenient word for the cumbrous expression “the force of circumstances.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_20"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_c('a'), _vm._v("We are all aspects of one another.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_20"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Blaming a man for what he “does” is in accordance with the same process of logic as blaming a door when it bangs or an object when it falls on your foot.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_2"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "Image",
      "src": "images/00002.jpg"
    }
  })])]), _c('div', {
    staticClass: "calibre_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("A school is an efficient instrument for reinforcing the stranglehold of the so-called “ego.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_20"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Much reading is also a struggling to “attain.”")])]), _vm._v(" "), _c('div', {
    staticClass: "mbp_pagebreak",
    attrs: {
      "id": "calibre_pb_37"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef97edf2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_021.vue
// module id = 123
// module chunks = 0